import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
    standalone: true,
    name: 'filterDeleted'
})
export class FilterDeletedPipe implements PipeTransform {
    transform(items: any[]): any[] {
        return items.filter(x => !x.IsDeleted);
    }
}